<template>
  <div class="main-section-container">
   <div class="customer-details-content" style="display: block;" id="user-details">
     <div class="grid-row">
       <div class="formBuilderHeader header">
         <h2 class="title" v-html="$store.state.texts.user.title"></h2>
       </div>
       <user-info-form-widget @change="userInfoChanged($event)" :submit-buttton-clicked="wasSubmitButtonClicked" translations-key="nissan.rs"></user-info-form-widget>
     </div>
   </div>
 </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    wasSubmitButtonClicked() {
      return this.$store.state.submitted
    }
  },
  methods: {
    userInfoChanged(event) {
      if (!event.detail) return;

      var userData = event.detail[0];
      this.$store.state.validation.isUserFormValid = userData.isFormValid;
      if (userData.isFormValid) {
        this.$store.state.form.user = userData.form.user;
        this.$store.state.form.gdpr = userData.form.gdpr;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
     .custom-selectbox {
         width: 30%!important;
         @media only screen and (max-width: 480px) {
             width: 75%!important;
         }
     }
     .selectedValue::after {
        border-left: 2px solid #eee;
        padding-left: .7142857143em;
        padding-right: .7142857143em;
        color: #c3002f;
        font-size: 1.1428571429em;
        line-height: 1.6;
        right: 0;
        margin-top: .125em;
     }
     //ERROR HANDLING
    .isInvalid {
      border: 2px solid red!important;
    }
    input.isInvalid::placeholder {
      color: red;
    }
    .error-message {
      display: block;
      color: red;
    }
    
    user-info-form-widget /deep/ > div {
      .range-tab {
          list-style: outside none none;
          padding: 0;
          margin: 0;
          border: 1px solid #ececec;
          border-bottom: 0 solid rgb(204, 204, 204);
      }
  
      .range-tab > li {
          display: inline-block;
          width: calc(100% / 2);
          background-color: rgb(236, 236, 236);
          border-right: 1px solid rgb(204, 204, 204);
          border-bottom: 0 solid rgb(204, 204, 204);
          font-family: "Nissan Bold",Verdana,Arial,sans-serif;
          font-size: 1.083rem;
          padding-top: 15px;
          padding-bottom: 15px;
          cursor: pointer;
          position: relative;
          min-height: 1px;
          vertical-align: middle;
          padding-left: 15px;
          padding-right: 15px;
          text-align: center;
          @media screen and (max-width: 990px) {
              width: 100%;
              border-right: 0 none;
          }
          &:last-child {
              border-right: 0 none;
          }
          &.active {
              background-color: rgb(255, 255, 255);
              border-bottom: 0 none;
              &::after {
                  content: "";
                  width: 92%;
                  margin: 0 4%;
                  background-color: #c3002f;
                  height: 3px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
              }
          }
      }
      .legal-info-component {
          .legal-info-label:after {
              font-family: icon-Nissan-Global;
              content: "";
              color: #c3002f;
          }
          a {
              color: #8a8a8a !important;
              text-decoration: underline !important;
              &:hover {
                  color: #8a8a8a !important;
                  text-decoration: none !important;
              }
          }
      }
      .form-group {
        max-width: initial !important;
      }
      .form-group label {
        margin-top: 2.8571428571em;
      }
      label.form-check-label {
        margin: 0;
        padding: 0;
        text-transform: uppercase !important;
      }
      fieldset {
        border-bottom: none !important;
      }
      h3 {
        border-top: none !important;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form/UserDetail.vue